import styled from 'styled-components';

export const TextWrapper = styled.div`
  display: inline-grid;
  align-items: stretch;
  min-width: 70px;
  width: fit-content;
`;

export const TextSpan = styled.span<{ $maxWidth?: string }>`
  grid-area: 1 / 1 / 2 / 2;
  visibility: hidden;
  height: 24px;
  width: fit-content;
  max-width: ${({ $maxWidth }) => $maxWidth || '100%'};
  ${({ theme: { font } }) => font.t1}
`;

export const TextInput = styled.input<{
  $isValid?: boolean;
  $maxWidth?: string;
}>`
  grid-area: 1 / 1 / 2 / 2;
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || '100%'};
  display: inline-block;
  box-sizing: content-box;
  padding: 0;
  height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: transparent;
  border: none;
  outline: none;
  padding-right: 8px;
  color: ${({ theme: { color }, $isValid }) => ($isValid ? color.ui2 : color.ac11)};
  ${({ theme: { font } }) => font.t1}

  &:focus {
    outline: none;
  }
`;

export const EditableContainer = styled.div<{
  $isValid: boolean;
  $isFocused: boolean;
  $align?: 'left' | 'center';
}>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) => ($align === 'left' ? 'flex-start' : 'center')};
  gap: 8px;
  min-width: 70px;
  height: 100%;
  border-bottom: 1px solid
    ${({ theme: { color }, $isFocused, $isValid }) =>
      $isFocused ? ($isValid ? color.s1 : color.ac11) : 'transparent'};

  padding: 0;
  cursor: text;

  i {
    visibility: hidden;
  }

  &:hover {
    i {
      visibility: ${({ $isFocused }) => ($isFocused ? 'hidden' : 'visible')};
    }
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 24px;
  fill: ${({ theme: { color } }) => color.s1};
`;

export const EditIcon = styled.button`
  height: 20px;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  cursor: pointer;
`;
